// extracted by mini-css-extract-plugin
module.exports =  {"nowrap":"d30e7684c4--nowrap--QbNay","wrap":"d30e7684c4--wrap--UqD6F"};